import { render, staticRenderFns } from "./fuw_verify.vue?vue&type=template&id=67941a42&scoped=true&"
import script from "./fuw_verify.vue?vue&type=script&lang=js&"
export * from "./fuw_verify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67941a42",
  null
  
)

export default component.exports